import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6","key":"svg-0"}],["path",{"d":"M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9","key":"svg-1"}],["path",{"d":"M16 9h2","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconDevicesOff = createReactComponent('outline', 'devices-off', 'DevicesOff', __iconNode);

export default IconDevicesOff;